// extracted by mini-css-extract-plugin
module.exports = {"modal-close":"askYDSlGTGD4wse6Su9z0"};